import { useCallback, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { actionCreators as apnActionCreators } from 'reduxBits/appNexus'
import { setPageOptions } from 'components/Placement/AstUtils'
import { get } from 'lodash'
import { loadGlimrTags } from 'utils/consent'

const AppnexusConfig = (props) => {
  const dispatch = useDispatch()

  const updateApnLoaded = useCallback(() => {
    const { device, inventory, loggedIn } = props
    const apnTagReady = typeof window !== 'undefined' && Boolean(window.apntag)

    if (apnTagReady) {
      const pageOptions = {
        device,
        inventory,
        loggedIn,
      }
      setPageOptions(pageOptions)
      dispatch(apnActionCreators.updateApnTagReady(apnTagReady))
    }
  }, [dispatch, props])

  useEffect(() => {
    document.addEventListener('apnLoaded', updateApnLoaded)
    loadGlimrTags(props)
    return () => {
      document.removeEventListener('apnLoaded', updateApnLoaded)
    }
  }, [props, updateApnLoaded])

  return null
}

const mapStateToProps = (state) => ({
  isAdBlockerActive: get(state, 'adBlocker.isActive'),
  glimrUrl: get(state, 'config.urls.glimrUrl'),
  apiUrl: get(state, 'config.urls.api'),
  userId: get(state, 'user.id'),
  loggedIn: get(state, 'authentication.loggedIn'),
  bearerToken: get(state, 'authentication.bearerToken'),
  inventory: get(state, 'StartPage.inventory'),
})

export default connect(mapStateToProps)(AppnexusConfig)
